import { render, staticRenderFns } from "./RegisterForm.vue?vue&type=template&id=790a87c6&scoped=true&"
import script from "./RegisterForm.vue?vue&type=script&lang=js&"
export * from "./RegisterForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790a87c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('790a87c6')) {
      api.createRecord('790a87c6', component.options)
    } else {
      api.reload('790a87c6', component.options)
    }
    module.hot.accept("./RegisterForm.vue?vue&type=template&id=790a87c6&scoped=true&", function () {
      api.rerender('790a87c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/js/Components/RegisterForm.vue"
export default component.exports